import { EditorType } from '@/types/feedback';

import type { CommentUserInfo, Pin } from '@/types/feedback';

const BI_EDITOR_VERSION: Partial<Record<EditorType, string>> = {
  [EditorType.Editor]: 'editor',
  [EditorType.EditorX]: 'editorx',
  [EditorType.Studio]: 'studio',
  [EditorType.Studio_Two]: 'studio_two',
  [EditorType.Odeditor]: 'odeditor',
};

/**
 * Maps the internal EditorType enum to the BI editor_version value
 * (catalog values: 'editor' / 'editorx' / 'studio').
 */
export function mapEditorVersion(editorType?: EditorType): string | undefined {
  if (!editorType) return undefined;
  return BI_EDITOR_VERSION[editorType];
}

/**
 * Whether the commenter that authored a pin's comment provided an email.
 * Maps to the BI comment_has_email field.
 */
export function pinCommentHasEmail(
  pin: Pin,
  commenterInfoMap: Record<string, CommentUserInfo>,
): boolean {
  if (!pin.commenterId) return false;
  return Boolean(commenterInfoMap[pin.commenterId]?.email);
}
